// Vendors
import React from 'react';
import { connectHitInsights, Hits } from 'react-instantsearch-dom';

// Components
import { ClearSearch } from '..';

// Helpers
import { truncateString } from '../../../../lib/utilities';

const ResourceHit = ({ hit, insights }) => {
  const {
    objectID,
    url,
    __queryID,
    __position,
    image,
    label,
    title,
    on_sale,
    recently_added,
    short_description,
    sale_price = undefined
  } = hit || {};

  return (
    <article
      key={objectID}
      data-object-id={objectID}
      data-query-id={__queryID}
      data-object-position={__position}
      className="card card-product"
    >
      <a href={`${url}?queryID=${__queryID}`}>
        <img src={image} className="card__media" alt={label} />
      </a>
      {on_sale && <span className="card__flag">On Sale</span>}
      {!on_sale && recently_added && <span className="card__flag">New</span>}
      <section className="card__body">
        <a href={`${url}?queryID=${__queryID}`}>
          <h5 className="card__title">{label}</h5>
          <p className="card__description">{short_description}</p>
        </a>
      </section>
    </article>
  );
};

const HitWithInsights = connectHitInsights(window.aa)(ResourceHit);

const ProductHits = ({ loading = false }) => {
  return (
    <div
      id="product-catalog-hits"
      className={`product-catalog-hits u--margin-top-20 product-catalog-hits__${
        loading ? 'loading' : ''
      }`}
    >
      <Hits hitComponent={HitWithInsights} />
    </div>
  );
};

export default ProductHits;
